module.exports = function() {
	return new Worker(__webpack_public_path__ + "854f6ccff95ba951b9a0.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./scripts/workers/yaml.worker.js
// module id = 387
// module chunks = 0